import React, { useState, useEffect } from "react";
import addToHomescreenIOS from "../assets/images/add_to_homescreen_ios.png";

function FirstVisit({ handleContinue, setIsFirstVisit }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isAndroid = /Android/.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("PWA installed");
        } else {
          console.log("PWA installation rejected");
        }
        setDeferredPrompt(null);
        setIsFirstVisit(false);
        localStorage.setItem("firstVisit", "true");
      });
    }
  };

  return (
    <div className="w-full h-svh flex flex-col my-8 justify-center items-center">
      {isAndroid || isIOS ? (
        <div className="flex flex-col items-center justify-center  w-full p-3 gap-6">
          <img className="w-[86px] h-[86px]" src="/favicon.ico" alt="" />

          <p className="text-[32px] text-center leading-[90%]">
            <span className="text-[#DA442D] font-[ClashDisplay-Semibold]">
              Dua
            </span>{" "}
            <span className="font-[ClashDisplay-Medium]">
              të <br /> ndryshme
            </span>
          </p>

          <p className="text-center font-[Biennale-Regular] text-[#361A0A] leading-[155%]">
            Shto në homescreen të <br /> telefonit për qasje të lehtë
          </p>

          {isAndroid && (
            <>
              <button
                onClick={handleInstallClick}
                className="bg-[#DA442D] text-white px-4 py-4 rounded-xl text-center font-[ClashDisplay-Semibold] w-[250px]"
              >
                Shkarko tani
              </button>

              <p className="text-center text-[#361A0A] font-[Biennale-Regular] leading-[155%]">
                ose{" "}
                <span
                  onClick={handleContinue}
                  className="text-[#DA442D] cursor-pointer font-bold"
                >
                  vazhdo
                </span>
              </p>
            </>
          )}

          {isIOS && (
            <>
              <img src={addToHomescreenIOS} width="200" alt="" />

              <button
                onClick={handleContinue}
                className="bg-[#DA442D] text-white px-4 py-4 rounded-xl text-center font-[ClashDisplay-Semibold] w-[250px]"
              >
                Vazhdo
              </button>
            </>
          )}
        </div>
      ) : (
        <button
          onClick={handleContinue}
          className="bg-[#DA442D] text-white px-4 py-4 rounded-xl text-center font-[ClashDisplay-Semibold] w-[250px]"
        >
          Vazhdo
        </button>
      )}
    </div>
  );
}

export default FirstVisit;
